import apiClient, { extractData } from "./client";

/**
 * Organization API (tree / chain / manager CRUD with audit).
 * Uses organization.view / organization.manage permissions.
 * Prefer syncEmployeeDirectManager from organizationalHierarchy.js
 * when mirroring the existing Employee.managerId flow.
 */

export async function getOrganizationStructures() {
  const response = await apiClient.get("/organization/structures");
  return extractData(response);
}

export async function updateOrganizationStructure(structureId) {
  const response = await apiClient.put("/organization/structure", {
    structureId,
  });
  return extractData(response);
}

export async function getOrganizationTree() {
  const response = await apiClient.get("/organization/tree");
  return extractData(response);
}

export async function getOrganizationChain(employeeId) {
  const response = await apiClient.get(`/organization/chain/${employeeId}`);
  return extractData(response);
}

export async function assignOrganizationManager(employeeId, managerId) {
  const response = await apiClient.post(
    `/organization/${employeeId}/manager`,
    { managerId },
  );
  return extractData(response);
}

export async function changeOrganizationManager(employeeId, newManagerId) {
  const response = await apiClient.patch(
    `/organization/${employeeId}/manager`,
    { newManagerId },
  );
  return extractData(response);
}

export async function removeOrganizationManager(employeeId) {
  const response = await apiClient.delete(
    `/organization/${employeeId}/manager`,
  );
  return extractData(response);
}
